const positions = Object.freeze({
  AFTER: 'after',
  BEFORE: 'before',
});

export const { AFTER, BEFORE } = positions;
